<template>
  <div class="text-center">
    <v-dialog :value="dialogValue" @input="onDialogInput" persistent width="620">
      <v-form ref="form" v-model="valid">
        <v-card style="border-radius: 20px">
          <!-- <v-card-title>
            <v-row class="pt-16" no-gutters>
              <span style="
                  font-size: clamp(1.4rem, 2.5vw, 4rem);
                  font-weight: 500;
                  color: #353535;
                  margin: auto;
                ">
                {{ $t("managepage.schedule") }}
              </span>
              <v-col cols="10" md="10" xs="10" sm="10"> </v-col>
            </v-row>
          </v-card-title> -->
          <v-card-title>
            <v-row class="pt-16" no-gutters>
              <v-col cols="1" md="1" xs="1" sm="1"></v-col>
              <v-col cols="10" md="10" xs="10" sm="10">
                <span style="font-size: 32px; font-weight: 500; color: #353535">
                  {{ isEditMode ? $t("shedulepage.editroom") : $t("managepage.schedule") }}
                </span>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-row no-gutters class="mt-3">
              <v-col cols="1" md="1" xs="1" sm="1"></v-col>
              <v-col cols="12" md="3" xs="4" sm="4" class="mt-2 mr-4">
                <span style="font-size: 18px; font-weight: 500; color: #353535">
                  {{ $t("roomsetting.roomname") }} :
                </span>
              </v-col>
              <v-col cols="12" md="7" xs="7" sm="7">
                <v-text-field
                  required
                  autofocus
                  :rules="roomnamerules"
                  outlined
                  v-model="scheduleroom"
                  dense
                  style="font-size: 12px"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="1" md="1" xs="1" sm="1"></v-col>
              <v-col cols="12" md="3" xs="4" sm="4" class="pt-2 mr-4">
                <span style="font-size: 20px; font-weight: 500; color: #353535">
                  {{ $t("button.btnstart") }} :
                </span>
                <!-- Date and time -->
              </v-col>
              <v-col cols="12" md="4" xs="7" sm="7" class="pr-2">
                <v-menu
                  v-model="datetime"
                  :close-on-content-click="false"
                  :nudge-right="45"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="displayDate"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      small
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    width="332px"
                    :min="minDate"
                    v-model="date"
                    @change="datetime = false"
                  ></v-date-picker>
                  <!-- <v-date-picker width="332px" :min="minDate" v-model="date" @input="menu2 = false"> -->
                  <!-- </v-date-picker> -->
                </v-menu>
              </v-col>
              <v-col cols="12" md="3" xs="7" sm="7" class="pr-2">
                <vue-timepicker
                  input-width="100%"
                  input-height="100px"
                  input-class="time-custom"
                  style="height: 40px;"
                  v-model="time"
                  :hour-range="showHour ? [[minHour, 23]] : [[0, 23]]"
                  :minute-range="showMinute ? rangeMinMinute : [[0, 59]]"
                >
                </vue-timepicker>
              </v-col>

              <!-- <v-spacer></v-spacer> -->
            </v-row>
            <v-row no-gutters class="pt-2">
              <v-col cols="1" md="1" xs="1" sm="1"></v-col>
              <v-col cols="12" md="3" xs="4" sm="4" class="pt-2 mr-4">
                <span style="font-size: 20px; font-weight: 500; color: #353535">
                  {{ $t("button.btnend") }} :
                </span>
                <!-- Date and time -->
              </v-col>
              <v-col cols="12" md="4" xs="7" sm="7" class="pr-2">
                <v-menu
                  v-model="datetimeend"
                  :close-on-content-click="false"
                  :nudge-right="45"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="displayDateEnd"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      small
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    width="332px"
                    :min="minDateend"
                    v-model="dateend"
                    @change="datetimeend = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3" xs="7" sm="7" class="pr-2">
                <vue-timepicker
                  input-width="100%"
                  input-height="100px"
                  input-class="time-custom"
                  v-model="timeend"
                  :hour-range="showHourend ? [[minHourend, 23]] : [[0, 23]]"
                  :minute-range="showMinuteend ? rangeMinMinuteend : [[0, 59]]"
                >
                </vue-timepicker>
              </v-col>
            </v-row>
            <!-- <v-row no-gutters class="text-right">
              <v-col cols="1" md="3" sm="3" xs="3"></v-col>
              <v-col cols="4" md="4" sm="4" xs="4">
                <vue-timepicker
                  v-if="$vuetify.breakpoint.xs"
                  v-model="time"
                  input-width="98px"
                  input-class="time-custom"
                  hide-clear-button
                  :hour-range="showHour ? [[minHour, 23]] : [[1, 24]]"
                  :minute-range="showMinute ? rangeMinMinute : [[0, 59]]"
                  hide-disabled-items
                >
                  <v-icon />
                </vue-timepicker>
                <vue-timepicker
                  v-if="!$vuetify.breakpoint.xs"
                  v-model="time"
                  input-width="100px"
                  input-class="time-custom"
                  hide-clear-button
                  :hour-range="showHour ? [[minHour, 23]] : [[1, 24]]"
                  :minute-range="showMinute ? rangeMinMinute : [[0, 59]]"
                  hide-disabled-items
                >
                  <v-icon />
                </vue-timepicker>
                <label for="default-picker"> </label>
              </v-col>
              <v-col cols="4" md="3" sm="3" xs="3">
                <v-text-field
                  v-if="!$vuetify.breakpoint.xs"
                  required
                  class="pl-6"
                  v-model="duration"
                  @keypress="filterKey"
                  placeholder="       60"
                  label="ระยะเวลา"
                  outlined
                  dense
                  :rules="[rules.duration]"
                >
                </v-text-field>
                <v-text-field
                  v-if="$vuetify.breakpoint.xs"
                  required
                  class="pl-6"
                  v-model="duration"
                  @keypress="filterKey"
                  placeholder="    60"
                  label="ระยะเวลา"
                  outlined
                  dense
                  :rules="[rules.duration]"
                >
                </v-text-field>
              </v-col>
              <v-col cols="2" md="2" sm="2" xs="2">
                <div class="pt-2 text-right" style="font-size: 18px; font-weight: 500; color: #353535;">นาที</div>
              </v-col>
              <div class="md-form md-outline mt-n2"></div>
              <v-col md="6" style="padding: 0px" class="mr12- ml-5">
                <div style="display: flex"></div>
              </v-col>
            </v-row> -->
            <v-row class="pb-2">
              <v-col cols="1" md="1" sm="1" sx="1"></v-col>
              <v-col cols="12" md="10" sm="10" sx="10" class="mt-n4 mb-n4">
                <v-btn
                  text
                  class="no-uppercase p-0 m-0"
                  style="color: #3d85c6; font-size: 18px; text-decoration: underline"
                  @click="clickToShowOptions"
                  >{{ $t("roomsetting.setting") }}</v-btn
                >
                <v-icon style="color: #3d85c6" @click="clickToShowOptions">
                  mdi-chevron-down
                </v-icon>
              </v-col>
            </v-row>
            <div v-if="showOptions">
              <v-form ref="form">
                <v-row no-gutters class="mt-4" v-if="false">
                  <v-col cols="1" md="1" xs="1" sm="1"></v-col>
                  <v-col cols="12" md="4" xs="4" sm="4" class="mt-2">
                    <span style="font-size: 18px; font-weight: 500; color: #353535">
                      เว็บไคลเอ็นต์:
                    </span>
                  </v-col>
                  <v-col cols="12" md="7" xs="7" sm="7">
                    <v-text-field outlined dense disabled v-model="type"></v-text-field>
                    <!-- <v-select
                  :items="web"
                  label="OneRTC (recommend)"
                  outlined
                  v-model="type"
                  dense
                  ></v-select> -->
                  </v-col>
                </v-row>
                <v-form ref="form">
                  <v-row no-gutters class="mb-n2">
                    <v-col cols="1" md="1" sm="1" sx="1"></v-col>
                    <v-col cols="12" md="3" sm="4" xs="12" class="pt-2 mr-4">
                      <span style="font-size: 18px; font-weight: 500; color: #353535">{{
                        $t("roomsetting.passwordrooms")
                      }}</span>
                    </v-col>
                    <v-col cols="12" md="7" sm="7" xs="12">
                      <!-- :rules="[filterInput]" -->
                      <v-text-field
                        :rules="[filterInput]"
                        outlined
                        dense
                        clearable
                        v-model="key"
                        @keypress="userpassword"
                        append-icon="mdi-dice-multiple"
                        @click:append="clickToAddPassword"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row no-gutters class="mb-n2" v-if="false">
                  <v-col cols="1" md="1" sm="1" sx="1"></v-col>
                  <v-col cols="12" md="4" sm="4" xs="4" class="pt-2">
                    <span style="font-size: 18px; font-weight: 500; color: #353535"
                      >ลิงก์โหวตสำหรับผู้เข้าร่วม</span
                    >
                  </v-col>
                  <v-col cols="12" md="6" sm="6" xs="6">
                    <v-text-field outlined dense v-model="linkVote"></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
              <!-- <v-row no-gutters class="mb-n2" v-if="false">
                <v-col cols="12" md="5" sm="12" xs="12" class="pt-2">
                  <span style="font-size: 16px; color:red;">*</span><span style="font-size: 16px;">vender</span>
                  </v-col>
                <v-col cols="12" md="6" sm="12" xs="12">
                  <v-select
                    :items="venders"
                    dense
                    outlined
                    item-text="name"
                    item-value="name"
                    style="font-size: 10px;"
                    v-model="vender"
                    placeholder="กรุณาเลือก"
                    persistent-placeholder
                  ></v-select>
                </v-col>
              </v-row> -->
              <v-row no-gutters v-if="this.userData.user.role != 'default'">
                <v-col cols="0" md="1" sm="1" sx="1"></v-col>
                <v-switch v-model="secretroom" inset rounded dense color="#64DD17"></v-switch>
                <span style="font-size: 16px; display: flex; align-items: center">{{
                  $t("roomsetting.secretmeeting")
                }}</span>
              </v-row>
              <!-- <div v-if="secretroom">
              <v-form ref="form">
              <v-row no-gutters class="mb-n2">
                <v-col cols="1" md="1" sm="1" sx="1"></v-col>
                <v-col cols="12" md="4" sm="4" xs="12" class="pt-2">
                  <span style="font-size: 16px;">กรุณาระบุ LOA</span>
                </v-col>
                <v-col cols="12" md="7" sm="7" xs="12">
                  <v-select
                  :items="loa"
                  label="กรุณาเลือก LOA ผู้เข้าร่วมประชุม"
                  outlined
                  v-model="secelctloa"
                  dense
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
            </div> -->
              <v-row no-gutters class="mt-n5">
                <v-col cols="1" md="1" sm="1" sx="1"></v-col>
                <v-col cols="12" md="5" sm="10" xs="10" class="pr-0">
                  <v-switch
                    v-model="stateLockRoom"
                    inset
                    rounded
                    dense
                    color="#64DD17"
                    :label="$t('roomsetting.lock')"
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-n5">
                <v-col cols="1" md="1" sm="1" sx="1"></v-col>
                <v-col cols="12" md="5" sm="10" xs="10" class="pr-0">
                  <v-switch
                    v-model="Allowguest"
                    inset
                    rounded
                    dense
                    color="#64DD17"
                    :label="$t('roomsetting.anonymous')"
                  ></v-switch>
                </v-col>
              </v-row>
            </div>
            <v-row class="pb-2">
              <v-col cols="1" md="1" sm="1" sx="1"></v-col>
              <v-col cols="12" md="10" sm="10" sx="10" class="mt-n3 mb-n4">
                <v-btn
                  text
                  class="no-uppercase p-0 m-0"
                  style="color: #04449f; font-size: 18px; text-decoration: underline"
                  @click="clickToShowOptionsmail"
                  >{{ $t("roomsetting.invitemail") }}</v-btn
                >
                <v-icon style="color: #04449f" @click="clickToShowOptionsmail">
                  mdi-chevron-down
                </v-icon>
              </v-col>
            </v-row>
            <div v-if="showOptionsmail">
              <v-row no-gutters class="mb-n2">
                <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                <v-col cols="12" md="4" sm="4" xs="4" class="pt-2">
                  <span style="font-size: 18px; font-weight: 500; color: #353535"
                    >{{ $t("roomsetting.subject") }} :</span
                  >
                  <!-- Mail subject -->
                </v-col>
                <v-col cols="12" md="7" sm="7" xs="7">
                  <v-text-field
                    outlined
                    dense
                    v-model="subject"
                    style="font-size: 12px"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                <v-col cols="12" md="4" sm="4" xs="12" class="pt-2">
                  <span style="font-size: 18px; font-weight: 500; color: #353535"
                    >{{ $t("roomsetting.to") }} :</span
                  >
                  <!-- Send mail to -->
                </v-col>
                <v-col cols="12" md="7" sm="7" xs="12">
                  <v-combobox
                    v-if="!isEditMode"
                    :rules="emailRules"
                    v-model="email"
                    @keypress="keyroomemail"
                    label="Email : example.ex@inet.co.th"
                    multiple
                    outlined
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                        @click:close="data.parent.selectItem(data.item)"
                      >
                        <v-avatar class="accent white--text" left>{{
                          data.item.slice(0, 1).toUpperCase()
                        }}</v-avatar>
                        {{ data.item }}
                        <v-icon small @click="data.parent.selectItem(data.item)">
                          $delete
                        </v-icon>
                      </v-chip>
                    </template>
                  </v-combobox>

                  <!-- Edit mode email fields -->
                  <v-autocomplete
                    v-if="isEditMode"
                    v-model="emailnew"
                    :label="this.$t('message.Selectemail')"
                    :items="items"
                    outlined
                    persistent-hint
                    :hint="this.$t('message.Emailsent')"
                    chips
                    clearable
                    deletable-chips
                    multiple
                    small-chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                        @click:close="data.parent.selectItem(data.item)"
                      >
                        <v-avatar class="accent white--text" left>{{
                          data.item.slice(0, 1).toUpperCase()
                        }}</v-avatar>
                        {{ data.item }}
                        <v-icon small @click="data.parent.selectItem(data.item)">
                          $delete
                        </v-icon>
                      </v-chip>
                    </template>
                  </v-autocomplete>

                  <!-- <v-text-field
                    outlined
                    dense
                    v-model="email"
                    type="email"
                    placeholder="example.ex@gmail.com,example.ex@inet.co.th"
                  ></v-text-field> -->
                </v-col>
              </v-row>
              <v-row no-gutters class="mb-n2" v-if="isEditMode">
                <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                <v-col cols="12" md="4" sm="4" xs="4" class="pt-2">
                  <span style="font-size: 18px; font-weight: 500; color: #353535"
                    >{{ $t("message.Addyouremail") }} :
                  </span>
                </v-col>
                <v-col cols="12" md="6" sm="6" xs="6">
                  <v-text-field
                    outlined
                    dense
                    v-model="emailToAdd"
                    type="email"
                    persistent-hint
                    :hint="this.$t('message.Addemail')"
                    small-chips
                    label="example.ex@gmail.com,example.ex@inet.co.th"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-col cols="2" md="2" xs="2" sm="2"></v-col>
            <v-col cols="4" md="4" xs="4" sm="4">
              <v-btn block rounded color="error" @click="closeDialog"
                >{{ $t("button.btncancel") }}
              </v-btn>
            </v-col>
            <v-col cols="4" md="4" xs="4" sm="4">
              <v-btn
                block
                rounded
                style="color: white"
                :disabled="!valid || !validpassword || !validTime || loadingBtn"
                :loading="loadingBtn"
                @click="onOkClick"
                color="#3D85C6"
              >
                {{ $t("button.btnok") }}
              </v-btn>
            </v-col>
            <v-col cols="2" md="2" xs="2" sm="2"></v-col>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import VueTimepicker from "vue2-timepicker";
import moment from "moment";

export default {
  components: {
    VueTimepicker,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "create",
      validator: value => ["create", "edit"].includes(value),
    },
    editData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      valid: true,
      validpassword: true,
      validTime: true,
      loadingBtn: false,
      onlyNumber: "this.value = this.value.replace(/[^0-9a-zA-Z!@#$%&*~+-฿/?]|/g, '')",
      jwt: require("jsonwebtoken"),
      showOptions: true,
      showOptionsmail: false,
      stateLockRoom: true,
      datetime: "",
      datetimeend: "",
      key: "",
      linkVote: "",
      date: null,
      menu: false,
      dateend: null,
      subject: "",
      email: [],
      emailnew: [],
      emailToAdd: "",
      items: [],
      secretroom: false,
      Allowguest: true,
      time: null,
      user_id: "",
      newtime: null,
      timeend: null,
      profile: null,
      showMinute: true,
      showMinuteend: true,
      // duration: '',
      web: ["OneRTC"],
      type: "OneRTC",
      scheduleroom: "",
      secelctloa: "",
      showHour: true,
      showHourend: true,
      minDate: moment().format("YYYY-MM-DD"),
      minDateend: moment().format("YYYY-MM-DD"),
      minCurrent: moment().format("YYYY-MM-DD"),
      minHourend: moment().format("HH"),
      minHour: moment().format("HH"),
      minMinute: moment().format("mm"),
      rangeMinMinute: [[moment().format("mm"), 59]],
      rangeMinMinuteend: [[moment().format("mm"), 59]],
      // Edit mode specific data
      meetid: "",
      userData: null,
      roomnamerules: [
        v => !!v || this.$t("loginpage.Pleasespecify"),
        v => /^[^ ]+/.test(v) || this.$t("loginpage.checkspace"),
      ],
      emailRules: [v => /.+@.+/.test(v) || this.$t("loginpage.Invalidformat")],
      rules: {
        required: value => !!value || this.$t("loginpage.required"),
        roomnamerules: value => {
          return value => /^[^ ]+/.test(value) || this.$t("loginpage.Invalidformat");
        },
      },
    };
  },
  created() {
    this.decodejwttoken();
  },
  computed: {
    ...mapState("dialog", ["scheduleSetting", "datarditroom"]),
    roomScheduleData() {
      return this.$store.state.dialog.dataRoomSchedule;
    },
    displayDate() {
      return moment(this.date).format("DD-MM-YYYY");
    },
    displayDateEnd() {
      return moment(this.dateend).format("DD-MM-YYYY");
    },
    dialogValue() {
      // Use v-model value prop ONLY if explicitly set by parent (not using default)
      // Check if parent is actually controlling this via v-model by seeing if value was changed from default
      // If using Vuex (default mode), always use scheduleSetting
      const usingVModel =
        this.$attrs.hasOwnProperty("value") || this.$listeners.hasOwnProperty("input");
      const result = usingVModel ? this.value : this.scheduleSetting;
      // console.log("[schedulesetting] dialogValue computed:", {
      //   value: this.value,
      //   scheduleSetting: this.scheduleSetting,
      //   usingVModel,
      //   hasValueAttr: this.$attrs.hasOwnProperty("value"),
      //   hasInputListener: this.$listeners.hasOwnProperty("input"),
      //   result,
      // });
      return result;
    },
    isEditMode() {
      // Determine if we're using props or Vuex mode
      const usingVModel =
        this.$attrs.hasOwnProperty("value") || this.$listeners.hasOwnProperty("input");
      const usingModePropsExplicitly = this.$attrs.hasOwnProperty("mode");

      let mode = false;

      // If parent explicitly set mode prop, use it
      if (usingModePropsExplicitly) {
        mode = this.mode === "edit";
      } else {
        // Otherwise, check datarditroom (Vuex mode)
        if (
          this.datarditroom &&
          typeof this.datarditroom === "object" &&
          Object.keys(this.datarditroom).length > 0
        ) {
          mode = !!this.datarditroom.meeting_id;
        }
      }

      // console.log("[schedulesetting] isEditMode computed:", {
      //   modeProp: this.mode,
      //   usingModePropsExplicitly,
      //   datarditroom: this.datarditroom,
      //   isObject: typeof this.datarditroom === "object",
      //   hasKeys:
      //     this.datarditroom && typeof this.datarditroom === "object"
      //       ? Object.keys(this.datarditroom).length
      //       : 0,
      //   meetingId:
      //     this.datarditroom && this.datarditroom.meeting_id ? this.datarditroom.meeting_id : null,
      //   result: mode,
      // });
      return mode;
    },
  },
  watch: {
    value(newVal, oldVal) {
      // Watch for prop changes
      // console.log("[schedulesetting] value prop changed:", {
      //   newVal,
      //   oldVal,
      //   editData: this.editData,
      // });
      if (newVal !== oldVal && newVal) {
        if (this.editData && this.editData.meeting_id) {
          // console.log("[schedulesetting] Loading edit data from editData prop");
          this.$nextTick(() => {
            this.loadEditData(this.editData);
          });
        } else {
          // console.log("[schedulesetting] Resetting form (create mode)");
          this.$nextTick(() => {
            this.resetForm();
          });
        }
      }
    },
    scheduleSetting(value, oldValue) {
      if (value !== oldValue && value) {
        // Use prop or datarditroom to determine mode
        const dataToLoad = this.editData || this.datarditroom;
        // console.log("[schedulesetting] Data to load:", {
        //   editData: this.editData,
        //   datarditroom: this.datarditroom,
        //   dataToLoad,
        //   isValidData: !!(dataToLoad && typeof dataToLoad === "object" && dataToLoad.meeting_id),
        // });

        // Check if dataToLoad is a valid object with meeting_id (not empty string)
        if (dataToLoad && typeof dataToLoad === "object" && dataToLoad.meeting_id) {
          // console.log("[schedulesetting] Loading edit data from Vuex watcher");
          this.$nextTick(() => {
            this.loadEditData(dataToLoad);
          });
        } else {
          // console.log("[schedulesetting] Resetting form from Vuex watcher (create mode)");
          this.$nextTick(() => {
            this.resetForm();
          });
        }
      }
    },
    email: function(data) {
      if (data !== "") {
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          const regex = /@/g;
          const myarr = data[index].match(regex);
          if (myarr === null || myarr === "") {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            data.forEach(e => {
              if ((e = pattern.test(e))) {
                this.emailRules = [v => !!v || ""];
              } else {
                this.emailRules = [v => pattern.test(v) || this.$t("loginpage.Invalidformat")];
              }
            });
          } else {
            const comma = element.split(",");
            if (comma.length > 1) {
              for (let index = 0; index < comma.length; index++) {
                const elementcomma = comma[index];
                const regex = /@/g;
                const myarrcomma = comma[index].match(regex);
                if (myarrcomma.length > 1) {
                  // console.log('myarrcommaif', myarrcomma)
                  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                  data.forEach(e => {
                    if ((e = pattern.test(e))) {
                      this.emailRules = [v => !!v || ""];
                    } else {
                      this.emailRules = [
                        v => pattern.test(v) || this.$t("loginpage.Invalidformat"),
                      ];
                    }
                  });
                } else {
                  // console.log('myarrcommaelse', myarrcomma)
                  this.emailRules = [];
                }
              }
            } else {
              // console.log('comma<=0', comma)
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              data.forEach(e => {
                if ((e = pattern.test(e))) {
                  this.emailRules = [v => !!v || ""];
                } else {
                  this.emailRules = [v => pattern.test(v) || this.$t("loginpage.Invalidformat")];
                }
              });
            }
          }
        }
      } else if (data === "") {
        this.emailRules = [];
      }
    },
    Allowguest(value) {
      if (value) {
        this.secretroom = false;
        // this.login = true
      }
    },
    secretroom(value) {
      if (value) {
        this.Allowguest = false;
        // this.login = false
      }
    },
    date(value, oldValue) {
      if (value !== this.minCurrent) {
        this.showHourend = false;
        this.showMinuteend = false;
      } else {
        this.showHourend = true;
        this.showMinuteend = true;
      }
      this.minDateend = moment(value).format("YYYY-MM-DD");
      if (value !== moment().format("YYYY-MM-DD") && value !== oldValue) {
        if (this.time >= "23:00") {
          var newdatetime = new Date(this.date);
          newdatetime.setDate(newdatetime.getDate() + 1);
          this.dateend = moment(newdatetime).format("YYYY-MM-DD");
        } else {
          this.dateend = value;
        }
        this.showHour = false;
        this.showMinute = false;
      } else {
        if (this.time >= "23:00") {
          var newdatetime = new Date(this.date);
          newdatetime.setDate(newdatetime.getDate() + 1);
          this.dateend = moment(newdatetime).format("YYYY-MM-DD");
        } else {
          this.dateend = value;
        }
        this.showHour = true;
        this.showMinute = true;
      }

      this.syncEndTimeConstraints();
    },
    dateend(value, oldValue) {
      this.minCurrent = value;
      if (value !== this.minDateend) {
        this.showHourend = false;
        this.showMinuteend = false;
      } else {
        this.showHourend = true;
        this.showMinuteend = true;
      }

      this.syncEndTimeConstraints();
    },
    time(value, oldValue) {
      // Check if value is empty or invalid format
      if (value === "" || value === null || value === undefined) {
        this.validTime = false;
        return;
      }

      const hasChanged = value !== oldValue;

      if (hasChanged) {
        const normalizedValue = this.normalizeTimeInput(value);
        if (normalizedValue && normalizedValue !== value) {
          this.time = normalizedValue;
          return;
        }
      }

      // Validate HH:mm format (must be string with numbers and colon)
      const timeFormatRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
      if (!timeFormatRegex.test(value)) {
        // console.log("Invalid end time format detected:", value);
        this.validTime = false;
        return;
      }

      if (value >= "23:00") {
        var newdatetime = new Date(this.date);
        newdatetime.setDate(newdatetime.getDate() + 1);
        this.dateend = moment(newdatetime).format("YYYY-MM-DD");
      }

      if (hasChanged) {
        this.newtime = value;
        this.timeend = moment(this.newtime, "HH:mm")
          .add(1, "h")
          .format("HH:mm");
        const splitTime = this.time.split(":");
        const selectedHour = parseInt(splitTime[0], 10);
        const selectedMinute = parseInt(splitTime[1], 10);
        const minSelectableHour = parseInt(this.minHour, 10);
        const isFutureHour =
          !Number.isNaN(selectedHour) &&
          !Number.isNaN(minSelectableHour) &&
          selectedHour > minSelectableHour;

        if (isFutureHour || this.date !== this.minDate) {
          this.rangeMinMinute = [[0, 59]];
        } else {
          const minSelectableMinute = parseInt(this.minMinute, 10);
          const minuteFloor = Number.isNaN(minSelectableMinute)
            ? parseInt(moment().format("mm"), 10)
            : minSelectableMinute;
          this.rangeMinMinute = [[minuteFloor, 59]];

          const shouldSnapMinute =
            !Number.isNaN(selectedMinute) &&
            selectedMinute < minuteFloor;

          if (shouldSnapMinute) {
            const hourString = splitTime[0].padStart(2, "0");
            const snappedMinute = minuteFloor.toString().padStart(2, "0");
            const snappedTime = `${hourString}:${snappedMinute}`;
            this.newtime = snappedTime;
            this.time = snappedTime;
            this.timeend = moment(snappedTime, "HH:mm")
              .add(1, "h")
              .format("HH:mm");
            return;
          }
        }
        this.validTime = true;
      }
    },
    timeend(value, oldValue) {
      // Check if value is empty or invalid format
      if (value === "" || value === null || value === undefined) {
        this.validTime = false;
        return;
      }

      const hasChanged = value !== oldValue;

      if (hasChanged) {
        const normalizedValue = this.normalizeEndTimeInput(value);
        if (normalizedValue && normalizedValue !== value) {
          this.timeend = normalizedValue;
          return;
        }
      }

      // Validate HH:mm format (must be string with numbers and colon)
      const timeFormatRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
      if (!timeFormatRegex.test(value)) {
        // console.log("Invalid end time format detected:", value);
        this.validTime = false;
        return;
      }
      // console.log(this.dateend);

      if (hasChanged) {
        this.syncEndTimeConstraints();
      }
    },
  },
  methods: {
    ...mapActions("dialog", ["setDialogScheduleSetting"]),
    syncEndTimeConstraints() {
      const startTime = this.newtime || this.time;
      const endTime = this.timeend;
      const timeFormatRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;

      if (
        !startTime ||
        !endTime ||
        !timeFormatRegex.test(startTime) ||
        !timeFormatRegex.test(endTime)
      ) {
        this.validTime = false;
        return;
      }

      const isSameDate = this.date === this.dateend;
      if (!isSameDate) {
        this.minHourend = "00";
        this.rangeMinMinuteend = [[0, 59]];
        this.validTime = true;
        return;
      }

      this.minHourend = startTime.slice(0, 2);

      const [startHourText, startMinuteText] = startTime.split(":");
      const [endHourText, endMinuteText] = endTime.split(":");
      const startHour = parseInt(startHourText, 10);
      const startMinute = parseInt(startMinuteText, 10);
      const endHour = parseInt(endHourText, 10);
      const endMinute = parseInt(endMinuteText, 10);
      const minuteFloorSameHour = Math.min(startMinute + 1, 59);

      if (endHour > startHour) {
        this.rangeMinMinuteend = [[0, 59]];
        this.validTime = true;
      } else if (endHour === startHour) {
        this.rangeMinMinuteend = [[minuteFloorSameHour, 59]];
        this.validTime = endMinute > startMinute;
      } else {
        this.rangeMinMinuteend = [[minuteFloorSameHour, 59]];
        this.validTime = false;
      }
    },
    async onOkClick() {
      if (this.loadingBtn) {
        return;
      }
      this.loadingBtn = true;
      try {
        await this.validate(this.valid);
      } finally {
        this.loadingBtn = false;
      }
    },
    onDialogInput(value) {
      // Emit input event for v-model support
      const usingVModel =
        this.$attrs.hasOwnProperty("value") || this.$listeners.hasOwnProperty("input");
      // console.log("[schedulesetting] onDialogInput called:", { value, usingVModel });
      if (usingVModel) {
        // console.log("[schedulesetting] Emitting input event for v-model");
        this.$emit("input", value);
      } else {
        // console.log("[schedulesetting] Using Vuex setDialogScheduleSetting");
        this.setDialogScheduleSetting(value);
      }
    },
    resetForm() {
      // console.log("[schedulesetting] resetForm called");
      this.date = moment().format("YYYY-MM-DD");
      this.dateend = moment().format("YYYY-MM-DD");
      this.time = moment().format("HH:mm");
      this.timeend = moment()
        .add(1, "hour")
        .format("HH:mm");
      this.minDate = moment().format("YYYY-MM-DD");
      this.minDateend = moment().format("YYYY-MM-DD");
      this.minHour = moment().format("HH");
      this.minHourend = moment().format("HH");
      this.minMinute = moment().format("mm");
      this.scheduleroom = "";
      this.email = [];
      this.emailnew = [];
      this.emailToAdd = "";
      this.items = [];
      this.key = "";
      this.subject = "";
      this.secretroom = false;
      this.Allowguest = true;
      this.stateLockRoom = true;
      this.showOptions = true;
      this.showOptionsmail = false;
      this.meetid = "";
      // console.log("[schedulesetting] resetForm completed");
    },
    loadEditData(dataSource) {
      // Use provided data source or fallback to datarditroom or editData prop
      const data = dataSource || this.editData || this.datarditroom;
      // console.log("[schedulesetting] loadEditData called:", {
      //   dataSource,
      //   editDataProp: this.editData,
      //   datarditroomState: this.datarditroom,
      //   finalData: data,
      // });
      if (!data || !data.setting) {
        // console.warn("[schedulesetting] No data or setting found to load");
        return;
      }

      // Safely load data
      this.items = data.setting.sended_mails || [];
      this.scheduleroom = data.roomname || "";
      this.meetid = data.meeting_id || "";
      this.type = data.type || "OneRTC";
      this.stateLockRoom = data.setting.meetingLock !== undefined ? data.setting.meetingLock : true;
      this.secretroom = data.setting.secretroom || false;
      this.Allowguest = data.setting.login !== undefined ? data.setting.login : true;

      // Parse start date with safety checks
      if (data.setting.startdate && data.setting.startdate.length >= 16) {
        var d = data.setting.startdate.substr(0, 2);
        var m = data.setting.startdate.substr(3, 2);
        var y = data.setting.startdate.substr(6, 4);
        this.date = y + "-" + m + "-" + d;
        this.time = data.setting.startdate.substr(11, 5);
      }

      // Parse end date with safety checks
      if (data.setting.enddate && data.setting.enddate.length >= 16) {
        var d1 = data.setting.enddate.substr(0, 2);
        var m1 = data.setting.enddate.substr(3, 2);
        var y1 = data.setting.enddate.substr(6, 4);
        this.dateend = y1 + "-" + m1 + "-" + d1;
        this.timeend = data.setting.enddate.substr(11, 5);
      }

      // Parse LOA
      if (data.loa === 1) {
        this.secelctloa = "LV.1";
      } else if (data.loa === 2) {
        this.secelctloa = "LV.2";
      } else if (data.loa === 3) {
        this.secelctloa = "LV.3";
      } else if (data.loa === 4) {
        this.secelctloa = "LV.4";
      } else {
        this.secelctloa = "";
      }

      // Parse key
      if (data.key === "123roominet!") {
        this.key = "";
      } else if (
        this.secelctloa !== null ||
        this.secretroom !== false ||
        data.key !== "123roominet!"
      ) {
        this.showOptions = true;
        let splitKey = data.key ? data.key.split(":inet!") : [""];
        this.key = splitKey[0];
      } else {
        this.showOptions = false;
      }
    },
    goPage(link) {
      this.$router.push(link).catch(() => {});
    },
    filterInput(value) {
      // Custom rule to check for any character without "number or English"
      // const regex = /^[a-zA-Z0-9!@#$%^&*+=._-]+$/;
      // return regex.test(value) || this.$t("roomsetting.alertpass");
      if (value.length < 4 && value.length != 0) {
        this.validpassword = false;
        return this.$t("roomsetting.alertpass");
      } else {
        this.validpassword = true;
        return true;
      }
    },
    userpassword(e) {
      // only english and number
      const key = e.which ? e.which : e.keyCode;
      if (key >= 33 && key <= 64) {
        return true;
      } // number
      if (key >= 65 && key <= 90) {
        return true;
      } // A-Z
      if (key >= 91 && key <= 125) {
        return true;
      } // a-z
      return e.preventDefault();
    },
    async validate(validate) {
      // console.log('validate', validate)
      // if(this.$refs.form.validate()) {
      if (validate === true) {
        // console.log('validate', validate)
        // console.log('roomScheduleData:', this.roomScheduleData);
        // if (this.roomScheduleData.length > 0) {
        //   console.log('Existing schedule format:', this.roomScheduleData[0].setting.startdate);
        // }
        // console.log('New schedule format:', this.date + " " + this.time);

        if (
          this.hasOverlap(this.roomScheduleData, {
            startdate: this.date + " " + this.time,
            enddate: this.dateend + " " + this.timeend,
          })
        ) {
          await this.$swal(
            this.$t("roomsetting.timeConflict.title"),
            this.$t("roomsetting.timeConflict.message"),
            "warning"
          );
        } else {
          // No overlap, proceed with creating the schedule
          await this.checkloa();
        }
      } else {
        await this.$swal(
          this.$t("loginpage.Invalidformat"),
          this.$t("loginpage.checkspace"),
          "warning" /*  */
        );
      }
      // }
    },
    hasOverlap(ranges, newRange) {
      // Check if ranges is empty or not an array
      if (!ranges || !Array.isArray(ranges) || ranges.length === 0) {
        return false;
      }

      // Parse new range dates using moment for consistency
      const start = moment(newRange.startdate, "YYYY-MM-DD HH:mm").toDate();
      const end = moment(newRange.enddate, "YYYY-MM-DD HH:mm").toDate();

      return ranges.some(({ meeting_id, setting }) => {
        // In edit mode, skip checking against the current meeting being edited
        if (this.isEditMode && meeting_id === this.meetid) return false;

        // Parse existing schedule dates - they're in DD/MM/YYYY HH:mm format
        const s = moment(setting.startdate, "DD/MM/YYYY HH:mm").toDate();
        const e = moment(setting.enddate, "DD/MM/YYYY HH:mm").toDate();

        // console.log("Existing start:", s, "Existing end:", e);
        // console.log("Checking: start < e?", start < e, "end > s?", end > s);

        // overlap occurs if start < e && end > s
        const hasOverlap = start < e && end > s;
        // console.log("Has overlap:", hasOverlap);
        return hasOverlap;
      });
    },
    clickToShowOptions() {
      this.showOptions = !this.showOptions;
      // this.clickToAddPassword()
    },
    clickToShowOptionsmail() {
      this.showOptionsmail = !this.showOptionsmail;
    },
    clickToAddPassword() {
      this.key = this.randomPassword(2);
    },
    closeDialog() {
      const usingVModel =
        this.$attrs.hasOwnProperty("value") || this.$listeners.hasOwnProperty("input");
      // Emit close event for v-model
      if (usingVModel) {
        this.$emit("input", false);
        this.$emit("close");
      } else {
        // console.log("[schedulesetting] Using Vuex to close dialog");
        // Fall back to Vuex
        this.setDialogScheduleSetting(false);
      }
      this.resetForm();
    },
    filterKey(e) {
      const key = e.which ? e.which : e.keyCode;
      if (key > 31 && (key < 48 || key > 57)) {
        return e.preventDefault();
      }
    },
    decodejwttoken() {
      var token = localStorage.getItem("user-token");
      const decryptedText = this.CryptoJS.AES.decrypt(token, process.env.VUE_APP_SECRET_KEY)
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, "");
      var data = this.jwt.decode(decryptedText);
      this.userData = data;
      // console.log('userData', this.userData)
      this.user_id = this.userData.user._id;
      // console.log('data.room', data)
    },
    myFunction() {
      var d = new Date();
      var n = d.getHours();
      var n2 = d.getMinutes();
      document.getElementById("default-picker").value = n + ":" + n2;
    },
    async checkloa() {
      if (this.type === "") {
        this.type = "OneRTC";
      }
      if (this.scheduleroom === "") {
        await this.$swal(
          this.$t("loginpage.Pleasespecify"),
          this.$t("roomsetting.roomname"),
          "warning" /*  */
        );
        return;
      }

      if (this.showOptions === true) {
        if (this.secretroom === true) {
          this.secelctloa = 0;
        } else {
          this.secelctloa = "";
        }
      }

      if (this.isEditMode) {
        await this.updateSchedule();
      } else {
        await this.checkemail();
      }
    },
    async updateSchedule() {
      // console.log("[schedulesetting] updateSchedule called");
      let avgemail = "";
      if (this.emailToAdd !== "" || this.emailnew !== "") {
        avgemail = [this.emailToAdd + "," + this.emailnew];
      }

      const startedFromVuex = !!(this.datarditroom && this.datarditroom.started === true);
      const startedFromProps = !!(this.editData && this.editData.started === true);
      if (startedFromVuex || startedFromProps) {
        // console.warn("[schedulesetting] Cannot update: meeting already started");
        await this.$swal(this.$t("message.closmeetingandopen"), "", "warning");
        return;
      }

      if (this.secelctloa === null) {
        this.secelctloa = "";
      } else if (this.showOptions === false || this.secretroom === false) {
        this.secelctloa = "";
      }

      const payload = {
        email: avgemail,
        meeting_id: this.meetid,
        name: this.scheduleroom,
        starttime: this.time,
        startdate: this.date,
        endtime: this.timeend,
        enddate: this.dateend,
        key: this.key,
        secretroom: this.secretroom,
        meetingLock: this.stateLockRoom,
        login: this.Allowguest,
        loa: this.secelctloa,
        subject: this.subject,
        type: this.type,
        vote: [this.linkVote],
      };

      if (this.scheduleroom === "") {
        this.$swal(this.$t("loginpage.Pleasespecify"), this.$t("roomsetting.roomname"), "warning");
      } else if (this.time === "") {
        this.$swal(this.$t("loginpage.Pleasespecify"), this.$t("message.time"), "warning");
      } else {
        try {
          const url = process.env.VUE_APP_API + "/api/lv1/room/update";
          // console.log("[schedulesetting] Updating schedule:", { url, payload });
          const response = await this.axios.put(url, payload);
          // console.log("[schedulesetting] Update successful:", response.data);

          // Close dialog
          const usingVModel =
            this.$attrs.hasOwnProperty("value") || this.$listeners.hasOwnProperty("input");
          if (usingVModel) {
            // console.log("[schedulesetting] Emitting updated event for v-model usage");
            this.$emit("input", false);
            this.$emit("updated", response.data);
          } else {
            // console.log("[schedulesetting] Using Vuex to close after update");
            this.setDialogScheduleSetting(false);
          }

          this.$swal(this.$t("loginpage.update") + this.$t("table.roomsname"), "", "success");
          this.resetForm();
        } catch (error) {
          // console.error("[schedulesetting] Update error:", error);
        }
      }
    },
    decodeJS(data) {
      try {
        var bytes = this.CryptoJS.AES.decrypt(data, process.env.VUE_APP_SECRET_KEY);
        var decryptedData = JSON.parse(bytes.toString(this.CryptoJS.enc.Utf8));
        return decryptedData;
      } catch (error) {
        // console.log(">>>>>>>>", error);
        return error;
      }
    },
    keyroomemail(e) {
      const key = e.which ? e.which : e.keyCode;
      if (key <= 32 || key >= 127) {
        return e.preventDefault();
      } else {
        return true;
      }
    },
    async checkemail() {
      // console.log('checkemail', this.email)
      if (
        this.email === "" ||
        this.email.length === 0 ||
        this.email === null ||
        this.email === undefined
      ) {
        // console.log('checkemail if', this.email)
        await this.checkroomschedule();
      } else {
        // console.log('checkemail else', this.email)
        for (let index = 0; index < this.email.length; index++) {
          const element = this.email[index];
          // console.log('element',element)
          const comma = element.split("@");
          const comma1 = element.split(".");
          // console.log('comma',comma)
          if (comma.length <= 1 || comma.length >= 3) {
            // console.log('checkemail else if', this.email)
            this.$swal(this.$t("loginpage.email"), this.$t("loginpage.Invalidformat"), "warning");
            break;
          } else {
            await this.checkroomschedule();
            break;
            // console.log('checkemail else else', this.email)
            // if(comma1.length <= 1 ||comma1.length >= 3){
            // this.$swal(this.$t("loginpage.email") , this.$t("loginpage.Invalidformat") , 'warning')
            // break
            // }else{
            //   this.checkroomschedule()
            //   break
            // }
          }
        }
      }
    },
    async checkroomschedule() {
      if (this.type === "") {
        this.type = "OneRTC";
      }
      var data = {
        name: this.scheduleroom,
        key: this.key === null ? '' : this.key,
        secretroom: this.secretroom,
        login: this.Allowguest,
        loa: this.secelctloa,
        email: this.email,
        type: this.type,
        meetingLock: this.stateLockRoom,
        subject: this.subject,
        endtime: this.timeend,
        enddate: this.dateend,
        starttime: this.time,
        startdate: this.date,
      };
      // console.log("data", data);
      try {
        const res = await this.axios.post(process.env.VUE_APP_API + "/api/lv1/room/schedule", data);
        // console.log('setItem', res.data.data)
        var datares = res.data;
        var schedule = this.decodeJS(datares.data.data);
        if (datares.result === "Success") {
          await this.$swal.fire({
            title: this.$t("loginpage.Successfully"),
            // text: this.$t("managepage.schedule"),
            html: `<h5>${this.$t("managepage.schedule")}</h5>
                <p style="font-size:16px; text-align:left; margin-top:10px;">
                  ${this.$t("roomsetting.roomname")}: <b>${this.scheduleroom}</b><br/>
                  ${this.$t("button.btnstart")}: <b>${this.displayDate} ${this.time}</b><br/>
                  ${this.$t("button.btnend")}: <b>${this.displayDateEnd} ${this.timeend}</b>
                  </p>`,
            icon: "success",
            showCancelButton: false,
            confirmButtonText: this.$t("button.btnok"),
            allowOutsideClick: false,
          });

          // Emit created event
          const usingVModel =
            this.$attrs.hasOwnProperty("value") || this.$listeners.hasOwnProperty("input");
          if (usingVModel) {
            // console.log("[schedulesetting] Emitting created event for v-model usage");
            this.$emit("input", false);
            this.$emit("created", schedule);
          }
          this.closeDialog();
          // this.createlogoschedule(schedule)
          this.decodejwttoken();
          this.scheduleroom = "";
          this.duration = "";
          this.subject = "";
          this.secretroom = false;
          this.Allowguest = true;
          this.stateLockRoom = true;
          this.email = "";
          this.key = "";
          this.showOptions = false;
        }
      } catch (err) {
        // console.error("[schedulesetting] Create schedule error:", err);
      }
    },
    createlogoschedule(data) {
      this.axios
        .post(process.env.VUE_APP_API + "/api/v1/theme/roomcreate", {
          meeting_id: data.meeting_id,
        })
        .then(res => {
          // console.log('res createroomlogo', res.data.result)
        })
        .catch(err => {
          // console.log("err createroomlogo", err.data.result);
        });
    },
    randomPassword(length) {
      var chars = "abcdefghijklmnopqrstuvwxyz";
      var char = "QWERTYUIOPLKJHGFDSAZXCVBNM";
      var number = "1234567890";
      var characters = "!@#$%^&*+=._-";
      var pass = "";
      var pass1 = "";
      var pass2 = "";
      var pass3 = "";
      var pass4 = "";
      for (var x = 0; x < length; x++) {
        pass += chars.charAt(Math.floor(Math.random() * chars.length));
        pass1 += number.charAt(Math.floor(Math.random() * number.length));
        pass2 += char.charAt(Math.floor(Math.random() * char.length));
        pass3 += characters.charAt(Math.floor(Math.random() * characters.length));
        pass4 = pass + pass1 + pass2 + pass3;
      }
      return pass4;
    },
    normalizeTimeInput(value) {
      if (typeof value !== "string" || value.indexOf(":") === -1) {
        return null;
      }

      const [rawHour = "", rawMinute = ""] = value.split(":");
      const normalizedHour = rawHour.padStart(2, "0");
      const hourValue = parseInt(normalizedHour, 10);
      if (Number.isNaN(hourValue)) {
        return null;
      }

      const minSelectableHour = parseInt(this.minHour, 10);
      const isFutureHour =
        !Number.isNaN(minSelectableHour) && hourValue > minSelectableHour;
      const isSameDateAsMin = this.date === this.minDate;

      const minSelectableMinute = parseInt(this.minMinute, 10);
      const defaultMinuteFloor = Number.isNaN(minSelectableMinute)
        ? parseInt(moment().format("mm"), 10)
        : minSelectableMinute;
      const minuteFloor = isFutureHour || !isSameDateAsMin ? 0 : defaultMinuteFloor;

      const minuteRegex = /^[0-5][0-9]$/;
      const minuteValue = parseInt(rawMinute, 10);
      const hasValidMinute = minuteRegex.test(rawMinute);
      const needsSnap =
        !hasValidMinute ||
        (Number.isNaN(minuteValue) ? true : minuteValue < minuteFloor);

      if (!needsSnap) {
        return null;
      }

      const snappedMinute = Math.max(minuteFloor, 0)
        .toString()
        .padStart(2, "0");
      return `${normalizedHour}:${snappedMinute}`;
    },
    normalizeEndTimeInput(value) {
      if (typeof value !== "string" || value.indexOf(":") === -1) {
        return null;
      }

      const [rawHour = "", rawMinute = ""] = value.split(":");
      const normalizedHour = rawHour.padStart(2, "0");
      const hourValue = parseInt(normalizedHour, 10);
      if (Number.isNaN(hourValue)) {
        return null;
      }

      const startHour = this.newtime ? parseInt(this.newtime.slice(0, 2), 10) : null;
      const startMinute = this.newtime ? parseInt(this.newtime.slice(3, 5), 10) : null;
      const isSameDate = this.date === this.dateend;

      const minuteRegex = /^[0-5][0-9]$/;
      let minuteFloor = 0;
      if (
        isSameDate &&
        startHour !== null &&
        startMinute !== null &&
        hourValue === startHour
      ) {
        minuteFloor = Math.min(startMinute + 1, 59);
      }

      const minuteValue = parseInt(rawMinute, 10);
      const hasValidMinute = minuteRegex.test(rawMinute);
      const needsSnap =
        !hasValidMinute ||
        (Number.isNaN(minuteValue) ? true : minuteValue < minuteFloor);

      if (!needsSnap) {
        return null;
      }

      const boundedMinuteFloor = Math.min(Math.max(minuteFloor, 0), 59);
      const snappedMinute = boundedMinuteFloor.toString().padStart(2, "0");
      return `${normalizedHour}:${snappedMinute}`;
    },
  },
};
</script>

<style scoped>
.time-custom {
  height: 40px !important;
  text-align: center;
  background: white;
  border: 1px solid #000 !important;
  border-radius: 5px;
}
</style>
